import React, { Component } from 'react'
import { Modal} from 'antd'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import Notification from '../Notification'
import PropagateLoader from '../SubmitingForm'
import ajax from '../../utils/ajax'
import functions from '../../utils/functions'


class EditHospitalPayment extends Component {
  state = {
    userId: functions.sessionGuard(),
    paymentName:"",
    paymentCode:"",
    paymentId:"",
  }

  componentDidMount(){
    this.setState({
      paymentName:this.props.visible.paymentName,
      paymentCode:this.props.visible.paymentCode,
      paymentId:this.props.visible.paymentId,
    })
    
  }

  handleEditCancel = () => {
    const sent = this.props
    this.setState({ visible: false })
    sent.handleEditCancel(false)
  }


  paymentName = (value)=> {
    this.setState({ paymentName: value.target.value })
  }

  paymentCode = (value)=> {
    this.setState({ paymentCode: value.target.value })
  }

  onPressEditCategory= async (event)=>{
    event.preventDefault()
    const { paymentName,paymentCode,paymentId} = this.state

    if (paymentName.length > 0 && 
      paymentCode.length >0 && 
      paymentId.length > 0 ) {
        this.setState({
          type: '',
          info: '',
          load:<PropagateLoader/>
        })

          //fetch category from the API
          const server_response = await ajax.editPaymentMethods(paymentName, paymentCode,this.state.userId,this.state.paymentId)

          if (server_response.status === "OK") {
            this.setState({
              type: 'alert alert-success',
              info: server_response.details.message,
              load: '',
            })
            window.location.reload()

        } else {

          this.setState({
            type: 'alert alert-danger',
            info: server_response.details.message,
            load: '',
          })

        }


      }else{
        this.setState({
          type: 'alert alert-danger',
          info: 'Please be advised to fill in all required fields - All fields are required',
          load:'',
        })
      }
  }


  render() {
    return (

        <Modal
        title = {"EDIT CLINIC - HOSPTIAL PAYMENT METHOD"}
        centered
        bodyStyle={{ paddingBottom: '0px', paddingTop: '0px' }}
        visible={this.props.visible.visible}
        maskClosable={false}
        footer={[null]}
        maskTransitionName=""
        onCancel={this.handleEditCancel}
        width={700}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: false }}
      >

<br/>
<div class="row">
<div class="col-sm-12 mobile-inputs">

{this.state.load}
  <Notification
        message={{
          type: this.state.type,
          info: this.state.info,
        }}
    />

<form method="post" onSubmit={this.onPressEditCategory}>
<div class="form-group row">
<div class="col-sm-6">
<input type="text" onChange={this.paymentName} value={this.state.paymentName} class="form-control form-txt-primary" />
</div>
<div class="col-sm-6">
<input type="text" onChange={this.paymentCode} value={this.state.paymentCode} class="form-control form-txt-primary"/>
</div>
</div>

<div class="form-group row">
<div class="col-sm-6">
</div>

</div>
<div class="row">
<div class="col-sm-4 card-header-right" >
<button type="submit" class="btn btn-primary btn-block mb-3">EDIT Payment Method</button>
 </div>
 </div>
</form>
</div>
</div>


     
      </Modal>

    )}}

    export default EditHospitalPayment